<template>
  <div>
    <div class="collection-detail-wrap">
      <div class="collection-detail">
        <div class="base-info">
          <div class="btn" v-if="userId !== baseInfo.userId">
            <a-button
              type="primary"
              @click="collectThis"
              ghost
              v-if="baseInfo.collected"
              >已收藏</a-button
            >
            <a-button type="primary" @click="collectThis" v-else
              >收藏论文集</a-button
            >
          </div>
          <div class="title">{{ baseInfo.name }}</div>
          <div class="summary">{{ baseInfo.summary }}</div>
          <div class="user">
            <div class="pic">
              <router-link
                :to="{ path: '/user/articles', query: { id: baseInfo.userId } }"
                target="_blank"
              >
                <img
                  v-if="
                    baseInfo.userInfoEntity && baseInfo.userInfoEntity.imgUrl
                  "
                  :src="imgSiteUrl + baseInfo.userInfoEntity.imgUrl"
                  alt=""
                />
                <img v-else src="~@/assets/img/head1.png" />
              </router-link>
            </div>
            <div
              class="username"
              v-if="baseInfo.userInfoEntity && baseInfo.userInfoEntity.nickname"
            >
              <router-link
                :to="{ path: '/user/articles', query: { id: baseInfo.userId } }"
                target="_blank"
              >
                {{ baseInfo.userInfoEntity.nickname }}
              </router-link>
            </div>
            <div class="date">
              {{ getDate(baseInfo.addTime, baseInfo.lstModTime) }}
            </div>
            <div class="clear"></div>
          </div>
          <div class="count">
            {{ numWan(baseInfo.collectQua) }}人收藏
            <a-divider type="vertical" />
            {{ numWan(baseInfo.articleQua) }}篇论文
          </div>
        </div>

        <div class="list">
          <div class="count">
            <div
              type="primary"
              class="button"
              ghost
              @click="switchStatus"
              style="boder: none"
              v-if="userId==baseInfo.userId"
            >
              <SettingOutlined />&nbsp;&nbsp;操作
            </div>

            <!-- <div
              type="primary"
              class="button"
              danger
              ghost
            >
              <span  v-if="manageStatus">全选</span>
            </div> -->

            <div
              type="primary"
              class="button"
              danger
              ghost
              v-if="selectedIds.length > 0"
              @click="showMyCollections"
            >
              添加至论文集
            </div>

            <div
              type="primary"
              class="button"
              danger
              ghost
              v-if="selectedIds.length > 0&&userId && userId === baseInfo.userId"
              @click="moveout"
            >
              移出论文集
            </div>
            共<span class="num">{{ numWan(baseInfo.articleQua) }}</span
            >篇论文
          </div>

          <div class="item" v-for="item in list" :key="item.id">
            <div class="title">
              <router-link
                :to="{ path: '/essay_detail', query: { id: item.id, type: 1 } }"
                target="_blank"
                >{{ item.title }}</router-link
              >
            </div>
            <div class="author" style="color:#666">
              {{ item.authors ? item.authors.join(" ") : "" }} - 《{{
                item.journalNameZH
              }}》 - {{ item.pubYear }}年{{ item.period }}期
            </div>
            <div class="desc">{{ item.summary }}</div>
            <div class="keywords">
              <div class="count" style="color: #aaa">
                <span class="browseCount"
                  ><i class="iconfont icon-liulan"></i>&nbsp;{{
                    item.browseQua
                  }}&nbsp;</span
                >
                <span class="collectCount"
                  ><i class="iconfont icon-shoucang"></i>&nbsp;{{
                    item.collectQua
                  }}&nbsp;</span
                >
                <span class="recCount"
                  ><i class="iconfont icon-dianzan_kuai"></i>&nbsp;{{
                    item.praiseQua
                  }}&nbsp;</span
                >
              </div>
            
              <a-tag v-for="i in item.topicList" :key="i.topicId">
                {{ i.topicName }}
              </a-tag>
              <div class="clearx"></div>
            </div>
            <div class="select" v-if="manageStatus">
              <check-circle-filled
                @click="selectIds(item.id)"
                v-if="selectedIds.indexOf(item.id) !== -1"
              />
              <div class="circle" @click="selectIds(item.id)" v-else></div>
            </div>
          </div>
          <div class="page">
            <a-pagination
              v-model:value="currentPage"
              show-quick-jumper
              :hideOnSinglePage="true"
              :total="baseInfo.articleQua"
              @change="changePage"
            />
          </div>
        </div>
      </div>
      <div class="right">
        <div class="hot-article">
          <div class="block-title">相关论文集</div>
          <div class="title-line"></div>
          <div class="articles" v-if="collections.length>0">
            <div class="item" v-for="item in collections" :key="item.id">
              <div class="title">
                <router-link
                  :to="{ path: '/collection_detail', query: { id: item.id } }"
                  target="_blank"
                  >{{ item.name }}</router-link
                >
              </div>
              <div class="date">
                {{ numWan(item.collectQua) }}人收藏
                <a-divider type="vertical" />
                {{ numWan(item.articleQua) }}篇论文
              </div>
            </div>
          </div>
          <div v-else class="articles">
            <a-empty>
              <template #description>
                <span> 暂无数据 </span>
              </template>
            </a-empty>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>


    <a-modal
      v-model:visible="visible"
      class="select-collection"
      centered
      width="400px"
      @ok="addEssayToMyCollections"
    >
      <template #title> 选择论文集 </template>
      <div
        class="list"
        style="
          border-bottom: 1px solid #f0f0f0;
          margin-bottom: 10px;
          padding-bottom: 5px;
        "
      >
        <div v-if="myCollections.length > 0">
          <a-checkbox-group v-model:value="selectedCollectionId">
            <div class="item" v-for="item in myCollections" :key="item.id">
              <a-checkbox :value="item.id">{{ item.name }}（{{ item.articleQua }}）</a-checkbox >
            </div>
          </a-checkbox-group>
        </div>
        <div v-else>
          <a-empty>
            <template #description>
              <span> 您还没有创建论文集 </span>
            </template>
          </a-empty>
        </div>
      </div>

      <div class="page" v-show="page.allSize > 10">
        <a-pagination size="small" v-model:current="page.currentPage" simple :total="page.allSize" :page-size="10" @change="changePagex" />
      </div>

      <div class="create" style="color: #e75934;cursor:pointer" @click="toCreate">
        <plus-outlined />创建论文集
      </div>
    </a-modal>

  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  createVNode,
  nextTick,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import config from "../../until/configs";
import Http from "../../until/http";
import {
  confirmLogin,
  getCookie,
  getLocalItem,
  messageTips,
  numWan,
} from "../../until/tools";
import {
  CheckCircleFilled,
  QuestionCircleOutlined,
  SettingOutlined,
} from "@ant-design/icons-vue";
import { Modal } from "ant-design-vue";

export default defineComponent({
  components: { CheckCircleFilled, SettingOutlined },
  setup() {
    const state = reactive({
      baseInfo: {},
      imgSiteUrl: config.imgSiteUrl,
      currentPage: 1,
      list: [],
      collections: [],
      selectedIds: [],
      manageStatus: false,
      myCollections:[],
      selectedCollectionId:[],
      visible:false,
      page:{}
    });
    const route = useRoute();
    const router = useRouter();
    let userId = computed(() => {
      let userInfo = getLocalItem("userInfo") || {};
      return userInfo.userId;
    });

    const id = computed(() => {
      return parseInt(route.query.id);
    });

    const changePage = (page) => {
       window.scrollTo(0, 0);
      getList(page);
    };

    const getList = (page) => {
      Http.getEssayByCollection({ aggId: id.value, currentPage: page }).then(
        (res) => {
          if (res) {
            if (res.aggArticleList) {
              Object.assign(state, {
                list: res.aggArticleList,
              });
            }
          }
        }
      );
    };

    const collectThis = () => {
      const sid = getCookie("z_sid");
      if (!sid) {
        confirmLogin();
        return false;
      }
      Http.scCollection({
        resId: id.value,
        resUserId: state.baseInfo.userId,
      }).then((res) => {
        if (res && res.status) {
          messageTips(res.message, 3);
          state.baseInfo.collected = !state.baseInfo.collected;
          router.go(0)
        } else {
          messageTips(res.message, 1);
        }
      });
       nextTick(()=>{
      })
    };

    const selectIds = (id) => {
      let index = state.selectedIds.indexOf(id);
      if (index === -1) {
        state.selectedIds.push(id);
      } else {
        state.selectedIds.splice(index, 1);
      }
    };

    const switchStatus = () => {
      Object.assign(state, {
        manageStatus: !state.manageStatus,
      });
      if (!state.manageStatus) {
        Object.assign(state, {
          selectedIds: [],
        });
      }
    };

    const moveout = () => {
      Modal.confirm({
        title: "提示",
        icon: createVNode(QuestionCircleOutlined),
        content: "您确定要移出这些论文吗？",
        centered: true,
        okText: "确定",
        cancelText: "取消",
        onOk() {
          Http.moveoutEssayFromCollection({
            aggId: id.value,
            id: state.selectedIds.join(","),
          }).then((res) => {
            if (res) {
              if (res.status) {
                messageTips(res.message, 3);
                Object.assign(state.baseInfo, {
                  articleQua:
                    state.baseInfo.articleQua - state.selectedIds.length,
                });
                Object.assign(state, {
                  manageStatus: false,
                  selectedIds: [],
                });
                getList(state.currentPage);
              } else {
                messageTips(res.message, 1);
              }
            }
          });
        },
      });
    };

    onMounted(() => {
      Http.getCollectionDetail({ aggId: id.value }).then((res) => {
        if (res && res.articleAggItem) {
          Object.assign(state, {
            baseInfo: res.articleAggItem,
          });
          document.title = res.articleAggItem.name + "-" + config.siteTitle;
        }
      });
     
      Http.getLikeCollection({ id: id.value }).then((res) => {
        if (res.articleAggItems) {
          Object.assign(state, {
            collections: res.articleAggItems,
          });
        }
      });
      getList(1);
    });

    const getDate = (addTime, lstModTime) => {
      if (addTime && lstModTime) {
        if (addTime === lstModTime) {
          return addTime.substring(0, 10) + "创建";
        } else {
          return lstModTime.substring(0, 10) + "更新";
        }
      }
    };

    const showMyCollections = ()=>{
      Object.assign(state, {
        visible:true
      });
      Http.addCollection({articleId:id.value}).then((res) => {
        if (res.articleAggList) {
          Object.assign(state, {
            myCollections: res.articleAggList,
            page: res.page,
          });
        }
      });
    }

    const changePagex = (e) => {
     Http.addCollection({articleId:id.value,currentPage: e}).then((res) => {
        if (res.articleAggList) {
          Object.assign(state, {
            myCollections: res.articleAggList,
            page: res.page,
          });
        }
      });
    };

    const addEssayToMyCollections = ()=>{
      if (state.selectedCollectionId.length === 0) {
        messageTips("请选择论文集", 2);
        return false;
      }
      Http.addEssayToMyCollections({
        aggId: state.selectedCollectionId.join(","),
        id: state.selectedIds,
      }).then((res) => {
        if (res) {
          if (res.status) {
            messageTips("添加成功", 3);
            Object.assign(state, {
              visible: false,
              selectedCollectionId: [],
              myCollections: [],
              selectedIds:[]
            });
          } else {
            messageTips(res.message, 1);
          }
        }
      });
    }

    const toCreate = () => {
      router.push({ path: "/essay_create_collection",query:{needback:1,articleId:state.selectedIds.join(',')} });
    };

    return {
      ...toRefs(state),
      id,
      getDate,
      changePage,
      userId,
      collectThis,
      selectIds,
      switchStatus,
      moveout,
      numWan,
      showMyCollections,
      addEssayToMyCollections,
      changePagex,
      toCreate
    };
  },
});
</script>

<style lang="scss">
@import "../../scss/_variables.scss";
.collection-detail-wrap {
  width: 1200px;
  margin: 0 auto;
  padding: 12px 0;
  .collection-detail {
    width: 900px;
    float: left;
    .base-info {
      background: #fff;
      border-radius: 2px;
      padding: 20px;
      .btn {
        float: right;
        margin-top: -5px;
      }
      .title {
        font-size: 18px;
        font-weight: bold;
        margin-right: 148px;
      }
      
      .summary {
        line-height: 24px;
        padding: 5px 0;
        padding-top: 14px;
      }

      .user {
        .pic {
          width: 30px;
          height: 30px;
          float: left;
          border-radius: 50%;
          overflow: hidden;
          background: #eee;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .username {
          float: left;
          line-height: 30px;
          font-size: 15px;
          margin-left: 5px;
          margin-right: 5px;
          a {
            color: #666;
          }
        }
        .date {
          font-size: 15px;
          line-height: 30px;
          color: #666;
        }
      }
      .count {
        font-size: 15px;
        margin-top: -28px;
        text-align: right;
        color: #666;
      }
    }

    .list {
      padding: 20px;
      background: #fff;
      border-radius: 2px;
      margin-top: 12px;
      .count {
        .num {
          color: #f00;
          padding: 0 5px;
        }
        .button {
          float: right;
          margin-right: 21px;
          color: #666;
          cursor: pointer;
          font-size: 16px;
        }
      }

      .item {
        border-bottom: 1px solid #efefef;
        // padding: 14px 18px 10px 14px;
        padding: 20px 20px;
        position: relative;
        .select {
          position: absolute;
          top: 16px;
          right: 20px;
          .anticon {
            font-size: 20px;
            color: $primary-color;
            cursor: pointer;
          }
          .circle {
            width: 20px;
            height: 20px;
            border: 2px solid #aaa;
            border-radius: 50%;
            cursor: pointer;
          }
        }
        .title {
          font-size: 18px;
          margin-bottom: 10px;
          font-weight: bold;
          line-height: 30px;
          a {
            color: #333;
          }
          a:hover {
            color: $primary-color;
          }
          font {
            color: $primary-color;
          }
        }
        .desc {
          line-height: 28px;
          margin-top: 4px;
          height: 56px;
          font-size: 15px;
          overflow: hidden;
          color: #666;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          &:hover{
            color: #333;
          }
        }
        .keywords {
          padding: 10px 0 10px 0;
          height: 48px;
          line-height: 48px;
          .count {
            float: right;
            color: #666;
            span {
              margin-left: 10px;
              .iconfont {
                font-size: 18px;
                position: relative;
                top: 1px;
              }
            }
          }
        }
      }

      .page {
        text-align: center;
        padding: 20px 0;
      }
    }
  }

  .right {
    width: 288px;
    float: right;
    .hot-article {
      background: #fff;
      border-radius: 2px;
      margin-bottom: 12px;
      padding: 5px 15px 12px;
      a.change {
        float: right;
        line-height: 38px;
        color: #333;
      }
      .block-title {
        display: inline-block;
        height: 49px;
        line-height: 50px;
        font-size: 16px;
      }
      .title-line {
        height: 0.5px;
        background: #f0f3f6;
        width: 308px;
        margin-left: -15px;
      }
      .articles {
        padding-top: 20px;
        .item {
          margin-bottom: 12px;
          padding-bottom: 12px;
          border-bottom: 1px solid #f0f3f6;
          a {
            color: #333;
          }
          a:hover {
            color: $primary-color;
          }
          .title {
            line-height: 25px;
            overflow: hidden;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .date {
            color: #999;
            margin-top: 5px;
          }
        }
        .item:last-child {
          border-bottom: none;
        }
      }
      .tags {
        padding: 20px 0 10px 0;
        .ant-tag {
          margin-bottom: 10px;
          font-size: 15px;
          padding: 3px 7px;
        }
      }
    }
  }
}
.page {
  text-align: center;
}
</style>
<style scoped>
.ant-tag {
  background: #fff !important;
}
</style>